<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>以中国式现代化全面推进中华民族伟大复兴- -深刻领会中国式现代化的中国特色和本质要求</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2022-11-11</span></p>
        <p>
          新蓝图鼓舞人心，谋新篇踔厉前行。长三角一体化示范区出台方案，探索跨区域生态产品价值实现机制；海南洋浦港开展封关项目建设，奋力提升港口现代化水平；南方五省区农村电网巩固提升工程全面展开，为超6000万户农村居民提供高质量的供电服务……各地区各部门各有关方面正以昂扬的精神状态、务实的工作作风贯彻落实党的二十大精神，在推进中国式现代化的实践中展现新担当新作为。
        </p>
        <p>
          以中国式现代化全面推进中华民族伟大复兴，是党的二十大擘画的宏伟蓝图。习近平总书记在党的二十大报告中对中国式现代化的本质要求作出科学概括：“坚持中国共产党领导，坚持中国特色社会主义，实现高质量发展，发展全过程人民民主，丰富人民精神世界，实现全体人民共同富裕，促进人与自然和谐共生，推动构建人类命运共同体，创造人类文明新形态。”这是我们党深刻总结我国和世界其他国家现代化建设的历史经验，对我国这样一个东方大国如何加快实现现代化在认识上不断深入、战略上不断成熟、实践上不断丰富而形成的思想理论结晶。深刻领会、系统把握中国式现代化的本质要求，就要增强贯彻落实的自觉性和坚定性，把这个本质要求落实到各项工作之中，在中国式现代化道路上撸起袖子加油干、风雨无阻向前行，把中华民族伟大复兴的中国梦变为现实。
        </p>
        <p>
          走自己的路，是我们党的全部理论和实践立足点，更是我们党百年奋斗得出的历史结论。党的十八大以来，以习近平同志为核心的党中央坚持和发展中国特色社会主义，推动物质文明、政治文明、精神文明、社会文明、生态文明协调发展，成功推进和拓展了中国式现代化，书写了经济快速发展和社会长期稳定两大奇迹新篇章，不断丰富和发展了人类文明新形态。实践充分证明，中国式现代化道路符合中国实际、反映中国人民意愿、适应时代发展要求，是创造人民美好生活、实现中华民族伟大复兴的康庄大道。前进道路上，不走封闭僵化的老路，不走改旗易帜的邪路，坚持以中国式现代化全面推进中华民族伟大复兴，我们就一定能把中国发展进步的命运牢牢掌握在自己手中，完成全面建设社会主义现代化国家的历史宏愿。
        </p>
        <p>
          全面建设社会主义现代化国家、全面推进中华民族伟大复兴，关键在党。以中国式现代化全面推进中华民族伟大复兴，必须坚持和加强党的全面领导。中国特色社会主义最本质的特征是中国共产党领导，中国特色社会主义制度的最大优势是中国共产党领导。前进道路上，更加自觉地维护习近平总书记党中央的核心、全党的核心地位，更加自觉地维护以习近平同志为核心的党中央权威和集中统一领导，把党的领导落实到党和国家事业各领域各方面各环节，就能确保我国社会主义现代化建设正确方向，确保拥有团结奋斗的强大政治凝聚力、发展自信心，集聚起万众一心、共克时艰的磅礴力量。
        </p>
        <p>
          团结才能胜利，奋斗才会成功。以中国式现代化全面推进中华民族伟大复兴，离不开亿万人民的团结奋斗。无论是实现“经济高质量发展取得新突破，科技自立自强能力显著提升”的目标任务，还是落实“健全人民当家作主制度体系，扩大人民有序政治参与”的重大部署，无论是兑现“不断实现人民对美好生活的向往”的庄严承诺，还是建设“天更蓝、山更绿、水更清”的美丽中国，只有把思想和行动统一到党的二十大精神上来，不折不扣抓好党中央重大战略部署的贯彻落实，才能在中国式现代化道路上，不断谱写全面建设社会主义现代化国家新篇章。
        </p>
        <p>
          “中国式现代化是中国共产党和中国人民长期实践探索的成果，是一项伟大而艰巨的事业。惟其艰巨，所以伟大；惟其艰巨，更显荣光。”让我们更加紧密地团结在以习近平同志为核心的党中央周围，全面贯彻习近平新时代中国特色社会主义思想，坚定志不改、道不变的决心，以“越是艰险越向前”的英雄气概、“敢教日月换新天”的昂扬斗志，把中国特色社会主义伟大事业不断推向前进。
        </p>
        <p style="text-indent: 0; font-weight: 700">
          声明:转载此文是出于传递更多信息、利于普法之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与广东东进联系，我们将及时更正、删除，谢谢。</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build6' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;二十大精神关键词解读... </span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build4' })">全面理解把握党的二十大...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build4' })">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;全面理解把握党的二十大...</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news5.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>